<div class="card mb-0">
    <div class="card-header">
        <h4 class="card-title">Intraday Price and Volume <ng-container *ngIf="lastEventDate">| {{lastEventDate}}</ng-container> | Time in CST</h4>
    </div>
    <div class="card-body">
        <app-echart [height]="type == 'crypto'? '483': '445'" [option]="volatilityChartOpt"></app-echart>
    </div>
</div>
